<template>
  <TopbarSpeedDial v-if="sysAdmin" :buttons="buttonsConfig" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

import {sysAdmin} from '@/utils/api'

export default {
  name: 'OrganizationSpeedDial',
  extends: {
    methods: {
      sysAdmin,
    },
  },
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Create new ... ',
          icon: 'add',
          to: 'new',
        },
      ],
    }
  },
  mounted() {},
  computed: {
    readOnlyUser() {
      const {roles_mask: rolesMask} = this.$store.getters.currentUser
      return rolesMask === 16 || rolesMask === 8
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/OrganizationSpeedDial.vue